import store from '../store'
import { action } from 'mobx'

export default class GiftModal {
    @action
    setGiftModalState(state) {
        store.giftModalState = state
    }
}
